import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@adeccoux/tag-ds";

const CompletePopUp = ({ handleClick, phrases, closePopup }) => {
    return (
        <Modal
            data-testid="modal-test"
            className="tag-ds full-width"
            open={true}
            onClose={() => closePopup()}
            hasIconClose={true}
            renderAsPortal
        >
            <ModalHeader><h4>{phrases?.["1002244"]}</h4></ModalHeader>
            <ModalBody>{phrases?.["20022496"]}</ModalBody>
            <ModalFooter>
                <Button className="mr2 b2" onClick={() => handleClick()}>
                    {phrases?.["10928"]}</Button>
            </ModalFooter>
        </Modal>
    );
}

export default CompletePopUp;